import React from 'react'

const Checkbox = props => {
  return <input type="checkbox" {...props} />
}

Checkbox.propTypes = {}

export default Checkbox
